/**
 *
 * Asynchronously loads the component for ApplicantsImportModal
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
